var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShiprocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "49.4446mm",
    height: "54.6922mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 381 422",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#452278",
    d: "M113 159c0,-68 63,-13 119,18 15,8 35,16 35,33 0,19 -20,25 -35,33 -134,76 -120,87 -120,-85zm-4 -99c25,-32 -9,-51 96,8 36,20 69,40 105,61 15,8 45,19 37,42 -3,9 -14,16 -24,16 -20,1 -207,-116 -240,-134 -23,-12 -45,-11 -64,4 -21,17 -19,33 -19,65 0,55 0,111 0,166 0,28 -4,50 13,68 16,17 34,20 61,15 0,-11 2,-24 -3,-32 -5,0 -39,18 -39,-26 -1,-37 -4,-216 5,-227 13,-17 39,-6 43,13 3,14 1,58 1,75 0,52 0,103 0,155 0,24 -2,51 9,68 36,56 106,-3 153,-30 33,-19 64,-37 98,-57 19,-11 31,-17 37,-39 8,-27 -4,-44 -15,-57 -10,2 -23,8 -29,17 6,10 17,13 14,29 -3,17 -57,41 -83,56 -38,23 -77,46 -115,67 -30,17 -46,-17 -33,-36 6,-8 200,-117 230,-135 17,-10 37,-29 33,-58 -6,-38 -57,-57 -100,-82 -39,-23 -76,-45 -115,-67 -56,-31 -117,39 -56,52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17EF3E",
    d: "M139 240c0,40 23,15 42,4 56,-31 63,-31 30,-51 -82,-47 -72,-55 -72,47z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiprocket);
export default __webpack_public_path__ + "static/media/Shiprocket.447d2e66040ea6ee5641195289d3dac3.svg";
export { ForwardRef as ReactComponent };